module.exports = __webpack_public_path__ + "img/pmui3.png.357beaa6.webp";